var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDecor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 144,
  height: 112,
  viewBox: "0 0 144 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H97L65 112H0V0Z",
  fill: "url(#decor_svg__paint0_linear_3176_3610)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M111 0H144L92 112H72L111 0Z",
  fill: "url(#decor_svg__paint1_linear_3176_3610)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "decor_svg__paint0_linear_3176_3610",
  x1: 115,
  y1: -5.50002,
  x2: 31.9999,
  y2: 130.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "decor_svg__paint1_linear_3176_3610",
  x1: 115,
  y1: -5.50002,
  x2: 31.9999,
  y2: 130.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})))));
export { SvgDecor as ReactComponent };
export default __webpack_public_path__ + "assets/icons/decor.3515bd.svg";